import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n';
import { messages } from '@/i18n/translations.js';
/* eslint-disable */
import adapter from 'webrtc-adapter';
/* eslint-enable */
Vue.use(VueI18n);

var lang = navigator.language || navigator.userLanguage;

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'es',
  messages
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
